module.exports = __webpack_public_path__ + "img/icons8-apple-jam-96.bbdd7516.png";